export const apiUrl = '/api/v1/';
export const execUrl = '/exec/';


// 현재 epoch 시간
export const nowEpoch = () => {
  return new Date().getTime() / 1000;
}

// epoch를 날짜 형태로 변환
export function timeFormatFromUTCEpoch(epochUTC, formatType) {
  epochUTC = Number(epochUTC);
  if (!!!epochUTC) {
    return '-';
  }
  if (typeof formatType === 'undefined') {
    formatType = 1;
  }

  const d = new Date(0); // The 0 there is the key, which sets the date to the epoch
  d.setUTCSeconds(epochUTC);

  const yyyy = d.getFullYear();
  const MM = d.getMonth() + 1;
  const dd = d.getDate();
  const hh = d.getHours();
  const mm = d.getMinutes();
  const ss = d.getSeconds();

  if (localStorage.getItem('language') === 'en') {
    if (formatType === 1) {
      return (
        fitTwoDigit(MM) +
        '/' +
        fitTwoDigit(dd) +
        '/' +
        yyyy +
        ' ' +
        fitTwoDigit(hh) +
        ':' +
        fitTwoDigit(mm) +
        ':' +
        fitTwoDigit(ss)
      );
    } else if (formatType === 2) {
      return fitTwoDigit(MM) + '/' + fitTwoDigit(dd) + '/' + yyyy + ' ' + fitTwoDigit(hh) + ':' + fitTwoDigit(mm);
    } else if (formatType === 3) {
      return fitTwoDigit(MM) + '/' + fitTwoDigit(dd) + '/' + yyyy;
    } else if (formatType === 10) {
      return fitTwoDigit(hh) + ':' + fitTwoDigit(mm) + ':' + fitTwoDigit(ss);
    } else {
      //
    }
  } else {
    if (formatType === 1) {
      return (
        yyyy +
        '-' +
        fitTwoDigit(MM) +
        '-' +
        fitTwoDigit(dd) +
        ' ' +
        fitTwoDigit(hh) +
        ':' +
        fitTwoDigit(mm) +
        ':' +
        fitTwoDigit(ss)
      );
    } else if (formatType === 2) {
      return yyyy + '-' + fitTwoDigit(MM) + '-' + fitTwoDigit(dd) + ' ' + fitTwoDigit(hh) + ':' + fitTwoDigit(mm);
    } else if (formatType === 3) {
      return yyyy + '-' + fitTwoDigit(MM) + '-' + fitTwoDigit(dd);
    } else if (formatType === 4) {
      return yyyy + '-' + fitTwoDigit(MM);
    } else if (formatType === 10) {
      return fitTwoDigit(hh) + ':' + fitTwoDigit(mm) + ':' + fitTwoDigit(ss);
    } else {
      //
    }
  }

  return false;
}

export function fitTwoDigit(n) {
  return n < 10 ? '0' + n : n;
}
